import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../../home/components/Footer';

export default function RoofingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const openScheduler = () => {
    const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (widget) widget.click();
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="cursor-pointer">
              <div className="text-2xl font-bold leading-tight text-[#2C2C2C]">RW Construction</div>
              <div className="text-sm leading-tight text-gray-600">Las Vegas LLC</div>
            </Link>
            <div className="hidden lg:flex items-center gap-8">
              <Link to="/" className="text-sm font-medium text-gray-700 hover:text-[#FF6B35] transition-colors cursor-pointer">Home</Link>
              <Link to="/services/pool-repair" className="text-sm font-medium text-gray-700 hover:text-[#FF6B35] transition-colors cursor-pointer">Pool Repair</Link>
              <Link to="/services/roofing" className="text-sm font-medium text-[#FF6B35] transition-colors cursor-pointer">Roofing</Link>
              <Link to="/services/synthetic-grass" className="text-sm font-medium text-gray-700 hover:text-[#FF6B35] transition-colors cursor-pointer">Synthetic Grass</Link>
              <Link to="/services/pavers" className="text-sm font-medium text-gray-700 hover:text-[#FF6B35] transition-colors cursor-pointer">Pavers</Link>
              <button onClick={openScheduler} className="bg-[#FF6B35] text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#E55A2B] transition-colors whitespace-nowrap cursor-pointer">
                Get Free Estimate
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative h-[70vh] flex items-center justify-center">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/d613171d7f47052d482834039e8b2633.jpg"
            alt="Professional Roofing Services Las Vegas"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>
        </div>
        <div className="relative z-10 container mx-auto px-4 text-center text-white">
          <div className="inline-flex items-center gap-2 bg-[#FF6B35] px-4 py-2 rounded-full mb-6">
            <i className="ri-home-4-line text-white"></i>
            <span className="text-white text-sm font-semibold">Expert Roofing Services</span>
          </div>
          <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Roofing Services in Las Vegas
          </h1>
          <p className="text-white/90 text-lg leading-relaxed mb-8 max-w-3xl mx-auto">
            From roof repairs to complete replacements, our licensed roofing contractors deliver exceptional results. We specialize in tile roofing, shingle installation, flat roofs, and emergency repairs throughout the Las Vegas Valley.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <button
              onClick={openScheduler}
              className="inline-flex items-center gap-2 bg-[#FF6B35] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#E55A2B] transition-all hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg"
            >
              <i className="ri-calendar-schedule-line text-xl"></i>
              Schedule Roof Inspection
            </button>
            <a
              href="tel:7025001790"
              className="inline-flex items-center gap-3 bg-white text-orange-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-50 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill text-2xl"></i>
              Call 702-500-1790
            </a>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-[#FF6B35] text-sm font-semibold tracking-wider uppercase">Our Expertise</span>
            <h2 className="text-4xl font-bold text-[#2C2C2C] mt-3 mb-4">Comprehensive Roofing Services</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">We handle all aspects of roofing to protect your home from the harsh Las Vegas desert climate.</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: 'ri-home-4-line', title: 'Roof Replacement', desc: 'Complete roof replacement with premium materials designed to withstand extreme desert heat and occasional storms.', features: ['Full tear-off', 'New underlayment', 'Premium shingles', 'Warranty included'] },
              { icon: 'ri-tools-line', title: 'Roof Repair', desc: 'Fast, reliable repairs for leaks, damaged shingles, flashing issues, and storm damage to extend your roof\'s life.', features: ['Leak repair', 'Shingle replacement', 'Flashing repair', 'Storm damage'] },
              { icon: 'ri-layout-grid-line', title: 'Tile Roofing', desc: 'Beautiful and durable tile roofing installation and repair, perfect for Las Vegas homes and desert aesthetics.', features: ['Clay tiles', 'Concrete tiles', 'Tile replacement', 'Re-roofing'] },
              { icon: 'ri-stack-line', title: 'Flat Roofing', desc: 'Expert flat roof installation and repair using TPO, EPDM, and modified bitumen for commercial and residential properties.', features: ['TPO roofing', 'EPDM rubber', 'Coating systems', 'Drainage solutions'] },
              { icon: 'ri-shield-check-line', title: 'Roof Inspection', desc: 'Thorough roof inspections to identify potential issues before they become costly problems.', features: ['Detailed report', 'Photo documentation', 'Maintenance plan', 'Free estimates'] },
              { icon: 'ri-alarm-warning-line', title: 'Emergency Repairs', desc: '24/7 emergency roofing services for sudden leaks, storm damage, and urgent repairs when you need them most.', features: ['24/7 availability', 'Fast response', 'Temporary fixes', 'Insurance help'] },
            ].map((service, index) => (
              <div key={index} className="bg-[#F8F6F3] rounded-2xl p-8 hover:shadow-xl transition-all group">
                <div className="w-16 h-16 bg-[#FF6B35] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <i className={`${service.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#2C2C2C] mb-3">{service.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">{service.desc}</p>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-sm text-gray-700">
                      <i className="ri-check-line text-[#FF6B35]"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Roofing Materials */}
      <section className="py-20 bg-[#F8F6F3]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-[#FF6B35] text-sm font-semibold tracking-wider uppercase">Quality Materials</span>
            <h2 className="text-4xl font-bold text-[#2C2C2C] mt-3 mb-4">Roofing Materials We Install</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">We work with top-quality roofing materials designed for the Las Vegas climate.</p>
          </div>
          <div className="grid md:grid-cols-4 gap-6">
            {[
              { icon: 'ri-stack-line', title: 'Asphalt Shingles', desc: 'Affordable, durable, and available in many colors and styles.' },
              { icon: 'ri-layout-grid-line', title: 'Clay & Concrete Tiles', desc: 'Classic Southwest look with excellent heat resistance.' },
              { icon: 'ri-copper-coin-line', title: 'Metal Roofing', desc: 'Long-lasting, energy-efficient, and low maintenance.' },
              { icon: 'ri-rectangle-line', title: 'Flat Roof Systems', desc: 'TPO, EPDM, and modified bitumen for flat roofs.' },
            ].map((material, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 text-center hover:shadow-lg transition-all">
                <div className="w-14 h-14 bg-[#FF6B35]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${material.icon} text-[#FF6B35] text-2xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-[#2C2C2C] mb-2">{material.title}</h3>
                <p className="text-gray-600 text-sm">{material.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-[#FF6B35] text-sm font-semibold tracking-wider uppercase">How It Works</span>
            <h2 className="text-4xl font-bold text-[#2C2C2C] mt-3 mb-4">Our Roofing Process</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">We follow a proven process to ensure quality results and complete customer satisfaction.</p>
          </div>
          <div className="grid md:grid-cols-4 gap-8">
            {[
              { step: '01', title: 'Free Inspection', desc: 'We thoroughly inspect your roof to identify all issues and provide an accurate assessment.' },
              { step: '02', title: 'Detailed Quote', desc: 'Receive a comprehensive quote with clear pricing, material options, and timeline.' },
              { step: '03', title: 'Expert Installation', desc: 'Our skilled roofers complete the work using premium materials and proven techniques.' },
              { step: '04', title: 'Final Walkthrough', desc: 'We review the completed work with you and provide warranty documentation.' },
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 bg-[#FF6B35] rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-white text-2xl font-bold">{item.step}</span>
                </div>
                <h3 className="text-xl font-bold text-[#2C2C2C] mb-3">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Project Gallery */}
      <section className="py-20 bg-[#F8F6F3]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-[#FF6B35] text-sm font-semibold tracking-wider uppercase">Our Work</span>
            <h2 className="text-4xl font-bold text-[#2C2C2C] mt-3 mb-4">Recent Roofing Projects</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">See the quality roofing work we deliver for Las Vegas homeowners.</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { img: 'https://readdy.ai/api/search-image?query=Beautiful%20new%20tile%20roof%20installation%20on%20luxury%20Las%20Vegas%20home%2C%20terracotta%20clay%20tiles%2C%20professional%20roofing%20work%2C%20sunny%20desert%20landscape%2C%20high%20quality%20architectural%20photography%20showing%20completed%20roof%20project&width=600&height=450&seq=roofing-work-001&orientation=landscape', title: 'Tile Roof Installation', location: 'Henderson, NV' },
              { img: 'https://readdy.ai/api/search-image?query=Modern%20asphalt%20shingle%20roof%20replacement%20on%20residential%20home%20Las%20Vegas%2C%20architectural%20shingles%20in%20charcoal%20gray%20color%2C%20professional%20roofing%20contractor%20work%2C%20clean%20finished%20roof%20with%20proper%20ventilation%2C%20sunny%20day%20photography&width=600&height=450&seq=roofing-work-002&orientation=landscape', title: 'Shingle Replacement', location: 'Summerlin, NV' },
              { img: 'https://readdy.ai/api/search-image?query=Commercial%20flat%20roof%20installation%20with%20TPO%20membrane%2C%20white%20reflective%20roofing%20material%2C%20professional%20flat%20roof%20work%20Las%20Vegas%2C%20HVAC%20units%20on%20rooftop%2C%20clean%20modern%20commercial%20building%20roof&width=600&height=450&seq=roofing-work-003&orientation=landscape', title: 'Flat Roof System', location: 'Las Vegas, NV' },
            ].map((project, index) => (
              <div key={index} className="group cursor-pointer">
                <div className="rounded-2xl overflow-hidden mb-4 shadow-lg">
                  <img
                    src={project.img}
                    alt={project.title}
                    className="w-full h-64 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <h3 className="text-lg font-bold text-[#2C2C2C]">{project.title}</h3>
                <p className="text-gray-500 text-sm flex items-center gap-1">
                  <i className="ri-map-pin-line text-[#FF6B35]"></i>
                  {project.location}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-[#2C2C2C]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-[#FF6B35] text-sm font-semibold tracking-wider uppercase">Why Choose Us</span>
              <h2 className="text-4xl font-bold text-white mt-3 mb-6">Las Vegas Roofing Experts</h2>
              <p className="text-white/80 text-base leading-relaxed mb-8">
                With over 20 years of experience in the Las Vegas Valley, we understand the unique challenges desert roofs face. From extreme heat to monsoon storms, we have the expertise to protect your home year-round.
              </p>
              <div className="grid grid-cols-2 gap-6">
                {[
                  { icon: 'ri-medal-line', title: '20+ Years', desc: 'Experience' },
                  { icon: 'ri-shield-star-line', title: 'Licensed', desc: '& Insured' },
                  { icon: 'ri-home-4-line', title: '1000+', desc: 'Roofs Completed' },
                  { icon: 'ri-24-hours-line', title: '24/7', desc: 'Emergency Service' },
                ].map((stat, index) => (
                  <div key={index} className="bg-white/10 rounded-xl p-5">
                    <i className={`${stat.icon} text-[#FF6B35] text-3xl mb-2 block`}></i>
                    <div className="text-white font-bold text-xl">{stat.title}</div>
                    <div className="text-white/60 text-sm">{stat.desc}</div>
                  </div>
                ))}
              </div>
              {/* Certifications */}
              <div className="mt-8">
                <h3 className="text-white font-semibold mb-4">Our Certifications</h3>
                <div className="flex flex-wrap gap-3">
                  {[
                    'GAF Certified',
                    'CertainTeed SELECT',
                    'NRCA Member',
                    'Owens Corning Preferred',
                    'OSHA Certified'
                  ].map((cert, index) => (
                    <div key={index} className="flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full">
                      <i className="ri-award-fill text-[#FF6B35]"></i>
                      <span className="text-white text-sm">{cert}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20roofing%20contractor%20on%20residential%20roof%20in%20Las%20Vegas%20wearing%20safety%20gear%20and%20hard%20hat%2C%20installing%20new%20shingles%2C%20skilled%20tradesman%20at%20work%2C%20sunny%20desert%20climate%2C%20high%20quality%20photography%20showing%20expert%20craftsmanship&width=600&height=700&seq=roofing-tech-001&orientation=portrait"
                alt="Professional Roofing Contractor Las Vegas"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-[#FF6B35] text-sm font-semibold tracking-wider uppercase">FAQ</span>
            <h2 className="text-4xl font-bold text-[#2C2C2C] mt-3 mb-4">Roofing Questions</h2>
          </div>
          <div className="space-y-4">
            {[
              { q: 'How long does a roof replacement take?', a: 'Most residential roof replacements take 1-3 days depending on the size and complexity. We\'ll provide a detailed timeline during your free estimate.' },
              { q: 'What roofing material is best for Las Vegas?', a: 'Tile roofing and reflective shingles are excellent choices for Las Vegas due to their heat resistance. We\'ll help you choose the best option for your home and budget.' },
              { q: 'Do you offer warranties on roofing work?', a: 'Yes! We offer comprehensive warranties on all our work, including manufacturer warranties on materials and our own workmanship warranty.' },
              { q: 'How do I know if I need a new roof?', a: 'Signs include missing or curling shingles, leaks, visible damage, or if your roof is over 20 years old. We offer free inspections to assess your roof\'s condition.' },
            ].map((faq, index) => (
              <div key={index} className="bg-[#F8F6F3] rounded-xl p-6">
                <h3 className="text-lg font-bold text-[#2C2C2C] mb-2">{faq.q}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-orange-500 to-red-500">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">Ready for a New Roof?</h2>
          <p className="text-white/90 text-lg mb-8">
            Get a free roof inspection and estimate from Las Vegas's trusted roofing experts.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <button
              onClick={openScheduler}
              className="inline-flex items-center gap-2 bg-white text-[#FF6B35] px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-100 transition-all hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg"
            >
              <i className="ri-calendar-schedule-line text-xl"></i>
              Schedule Free Inspection
            </button>
            <a
              href="tel:7025001790"
              className="inline-flex items-center gap-3 bg-white text-orange-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-50 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill text-2xl"></i>
              Call 702-500-1790 Today
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
